/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type SputumTestMaterialDtoTestMaterial =
  (typeof SputumTestMaterialDtoTestMaterial)[keyof typeof SputumTestMaterialDtoTestMaterial];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SputumTestMaterialDtoTestMaterial = {
  SPUTUM_FROM_THE_AIRWAYS: 'SPUTUM_FROM_THE_AIRWAYS',
  OTHER_MATERIAL_FROM_THE_AIRWAYS: 'OTHER_MATERIAL_FROM_THE_AIRWAYS',
  OTHER_MATERIAL: 'OTHER_MATERIAL',
} as const;
